/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsVertical = createReactComponent("arrows-vertical", "IconArrowsVertical", [
  ["path", { d: "M8 7l4 -4l4 4", key: "svg-0" }],
  ["path", { d: "M8 17l4 4l4 -4", key: "svg-1" }],
  ["path", { d: "M12 3l0 18", key: "svg-2" }]
]);

export { IconArrowsVertical as default };
//# sourceMappingURL=IconArrowsVertical.js.map
